var map = {
	"../pages/administrador/administrador.module": [
		914,
		36
	],
	"../pages/ajustes/ajustes.module": [
		915,
		35
	],
	"../pages/alineacion/alineacion.module": [
		916,
		34
	],
	"../pages/amonestaciones/amonestaciones.module": [
		918,
		33
	],
	"../pages/asistentes/asistentes.module": [
		917,
		32
	],
	"../pages/auxiliares/auxiliares.module": [
		920,
		31
	],
	"../pages/cambios/cambios.module": [
		919,
		30
	],
	"../pages/custodia/custodia.module": [
		921,
		29
	],
	"../pages/declaraciones/declaraciones.module": [
		923,
		28
	],
	"../pages/derechos/derechos.module": [
		922,
		27
	],
	"../pages/designaciones-completas/designaciones-completas.module": [
		924,
		26
	],
	"../pages/entrenadores/entrenadores.module": [
		925,
		25
	],
	"../pages/equipo/equipo.module": [
		926,
		24
	],
	"../pages/finalizar/finalizar.module": [
		927,
		23
	],
	"../pages/firmas/firmas.module": [
		928,
		22
	],
	"../pages/goles/goles.module": [
		929,
		21
	],
	"../pages/incidencias/incidencias.module": [
		930,
		20
	],
	"../pages/incluir-jugador/incluir-jugador.module": [
		931,
		19
	],
	"../pages/jugadores/jugadores.module": [
		932,
		18
	],
	"../pages/lesionados/lesionados.module": [
		933,
		17
	],
	"../pages/login/login.module": [
		934,
		16
	],
	"../pages/modal-activar-alineaciones/modal-activar-alineaciones.module": [
		935,
		15
	],
	"../pages/modal-codigo-amonestacion/modal-codigo-amonestacion.module": [
		936,
		14
	],
	"../pages/modal-dorsal/modal-dorsal.module": [
		937,
		13
	],
	"../pages/modal-image/modal-image.module": [
		938,
		12
	],
	"../pages/modal-motivos/modal-motivos.module": [
		939,
		11
	],
	"../pages/modal-recibi/modal-recibi.module": [
		941,
		10
	],
	"../pages/modal-super/modal-super.module": [
		940,
		9
	],
	"../pages/nueva-persona/nueva-persona.module": [
		942,
		8
	],
	"../pages/otros-auxiliares/otros-auxiliares.module": [
		943,
		7
	],
	"../pages/participacion/participacion.module": [
		944,
		6
	],
	"../pages/quinteto/quinteto.module": [
		947,
		5
	],
	"../pages/registro-logs/registro-logs.module": [
		945,
		4
	],
	"../pages/resultado/resultado.module": [
		946,
		3
	],
	"../pages/resumen/resumen.module": [
		949,
		2
	],
	"../pages/salir/salir.module": [
		948,
		1
	],
	"../pages/tiempo-muerto/tiempo-muerto.module": [
		950,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 276;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 276
// module chunks = 37